module.exports = __webpack_public_path__ + "static/media/icm-logo.45c57165.png";